import { useContext } from 'react'
import { SidebarContext } from '../sidebar-provider'

export const useSidebar = () => useContext(SidebarContext)
